(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.announcement-bar');

    sections.forEach(function (section) {
      var track = section.querySelector('[data-announcement-track]');
      if (!track) return;

      var items = Array.from(section.querySelectorAll('.announcement-bar__item'));
      var currentIndex = 0;
      var intervalId = null;
      var autoplayInterval = parseInt(section.getAttribute('data-autoplay-speed')) || 5000;

      function isMobile() {
        return window.matchMedia('(max-width: 767px)').matches;
      }

      function showItem(index) {
        items.forEach(function (item, i) {
          if (i === index) {
            item.setAttribute('aria-hidden', 'false');
          } else {
            item.setAttribute('aria-hidden', 'true');
          }
        });
      }

      function nextItem() {
        currentIndex = (currentIndex + 1) % items.length;
        showItem(currentIndex);
      }

      function startAutoplay() {
        stopAutoplay();
        if (isMobile() && items.length > 1) {
          intervalId = setInterval(nextItem, autoplayInterval);
        }
      }

      function stopAutoplay() {
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        }
      }

      function handleResize() {
        if (isMobile()) {
          showItem(currentIndex);
          startAutoplay();
        } else {
          stopAutoplay();
          items.forEach(function (item) {
            item.setAttribute('aria-hidden', 'false');
          });
        }
      }

      track.addEventListener('mouseenter', stopAutoplay);
      track.addEventListener('mouseleave', function () {
        if (isMobile()) startAutoplay();
      });

      track.addEventListener('focusin', stopAutoplay);
      track.addEventListener('focusout', function () {
        if (isMobile()) startAutoplay();
      });

      var resizeTimeout;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(handleResize, 150);
      });

      handleResize();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["billboard"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBillboard(section) {
      var videoContainer = section.querySelector('.billboard__video');
      var video = section.querySelector('.billboard__video-element');
      var playButton = section.querySelector('.billboard__play-button');

      if (!videoContainer || !video || !playButton) return;

      playButton.addEventListener('click', function () {
        videoContainer.classList.add('is-playing');
        video.play();
      });

      video.addEventListener('ended', function () {
        videoContainer.classList.remove('is-playing');
      });

      video.addEventListener('pause', function () {
        if (video.currentTime === 0 || video.currentTime === video.duration) {
          videoContainer.classList.remove('is-playing');
        }
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.billboard[data-section-id]').forEach(initBillboard);
    });

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.billboard[data-section-id]');
      if (section) initBillboard(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel-featured-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-carousel-featured-product]');

    sections.forEach(function (section) {
      var track = section.querySelector('[data-carousel-track]');
      var prevBtn = section.querySelector('[data-carousel-prev]');
      var nextBtn = section.querySelector('[data-carousel-next]');

      if (!track) return;

      var getSlideWidth = function () {
        var slide = track.querySelector('.carousel-featured-product__slide');
        return slide ? slide.offsetWidth : window.innerWidth;
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({
            left: -getSlideWidth(),
            behavior: 'smooth',
          });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: getSlideWidth(), behavior: 'smooth' });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    const SELECTORS = {
      drawer: '[data-cart-drawer]',
      backdrop: '[data-cart-backdrop]',
      panel: '.cart-drawer__panel',
      close: '[data-cart-close]',
      empty: '[data-cart-empty]',
      filled: '[data-cart-filled]',
      footer: '[data-cart-footer]',
      items: '[data-cart-items]',
      cartCount: '[data-drawer-cart-count]',
      subtotal: '[data-cart-subtotal]',
      notification: '[data-cart-notification]',
      notificationClose: '[data-notification-close]',
      notificationViewCart: '[data-notification-view-cart]',
      notificationProduct: '[data-notification-product]',
      notificationImage: '[data-notification-image]',
      notificationTitle: '[data-notification-title]',
      notificationVariant: '[data-notification-variant]',
      notificationPrice: '[data-notification-price]',
      lineItem: '[data-line-item]',
      removeItem: '[data-remove-item]',
      decreaseQuantity: '[data-decrease-quantity]',
      increaseQuantity: '[data-increase-quantity]',
      quantityValue: '[data-quantity-value]',
      linePrice: '[data-line-price]',
      quickAdd: '[data-quick-add]',
    };

    let drawer, notification, notificationTimeout;

    function hasMeaningfulVariantTitle(variantTitle) {
      if (!variantTitle) return false;

      const normalizedTitle = String(variantTitle).trim().toLowerCase();
      if (!normalizedTitle) return false;

      // Default one-variant titles Shopify may return in different storefront languages.
      const defaultVariantTitles = new Set([
        'default title',
        'standardtitel',
        'titre par defaut',
        'titre par défaut',
        'titolo predefinito',
        'titulo predeterminado',
        'título predeterminado',
      ]);

      return !defaultVariantTitles.has(normalizedTitle);
    }

    function init() {
      drawer = document.querySelector(SELECTORS.drawer);
      notification = document.querySelector(SELECTORS.notification);

      if (!drawer) return;

      bindEvents();
    }

    function bindEvents() {
      // Close buttons
      document.querySelectorAll(SELECTORS.close).forEach(btn => {
        btn.addEventListener('click', closeDrawer);
      });

      // Backdrop click
      const backdrop = drawer.querySelector(SELECTORS.backdrop);
      if (backdrop) {
        backdrop.addEventListener('click', closeDrawer);
      }

      // Notification close
      const notificationCloseBtn = notification?.querySelector(SELECTORS.notificationClose);
      if (notificationCloseBtn) {
        notificationCloseBtn.addEventListener('click', closeNotification);
      }

      // Notification view cart
      const notificationViewCartBtn = notification?.querySelector(SELECTORS.notificationViewCart);
      if (notificationViewCartBtn) {
        notificationViewCartBtn.addEventListener('click', function () {
          closeNotification();
          openDrawer();
        });
      }

      // Line item actions - delegated
      drawer.addEventListener('click', handleLineItemAction);

      // Quick add in recommendations - delegated
      drawer.addEventListener('click', handleQuickAdd);

      // Keyboard handling
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          if (notification?.getAttribute('aria-hidden') === 'false') {
            closeNotification();
          } else if (drawer?.getAttribute('aria-hidden') === 'false') {
            closeDrawer();
          }
        }
      });

      // Listen for cart events
      document.addEventListener('cart:open', openDrawer);
      document.addEventListener('cart:close', closeDrawer);
      document.addEventListener('cart:item-added', handleItemAdded);
      document.addEventListener('cart:updated', handleCartUpdated);
    }

    function openDrawer() {
      if (!drawer) return;

      closeNotification();
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');

      // Focus trap - focus first focusable element
      const panel = drawer.querySelector(SELECTORS.panel);
      if (panel) {
        const firstFocusable = panel.querySelector(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (firstFocusable) {
          firstFocusable.focus();
        }
      }
    }

    function closeDrawer() {
      if (!drawer) return;

      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
    }

    function openNotification() {
      if (!notification) return;

      closeDrawer();
      notification.setAttribute('aria-hidden', 'false');

      // Auto-close after 30 seconds
      clearTimeout(notificationTimeout);
      notificationTimeout = setTimeout(closeNotification, 30000);
    }

    function closeNotification() {
      if (!notification) return;

      clearTimeout(notificationTimeout);
      notification.setAttribute('aria-hidden', 'true');
    }

    function handleItemAdded(event) {
      const { product, variant, quantity, image, price } = event.detail || {};

      if (notification && product) {
        // Update notification content
        const imageContainer = notification.querySelector(SELECTORS.notificationImage);
        const titleEl = notification.querySelector(SELECTORS.notificationTitle);
        const variantEl = notification.querySelector(SELECTORS.notificationVariant);
        const priceEl = notification.querySelector(SELECTORS.notificationPrice);

        if (imageContainer && image) {
          imageContainer.innerHTML = `<img src="${image}" alt="${product}" loading="lazy">`;
        }
        if (titleEl) titleEl.textContent = product;

        if (variantEl) {
          const showVariant = hasMeaningfulVariantTitle(variant);
          variantEl.textContent = showVariant ? variant : '';
          variantEl.style.display = showVariant ? 'block' : 'none';
        }
        if (priceEl) priceEl.textContent = price || '';

        openNotification();
      }

      // Refresh cart data
      refreshCart();
    }

    function handleCartUpdated(event) {
      const cart = event.detail?.cart;
      if (cart) {
        updateCartUI(cart);
      }
    }

    function handleLineItemAction(event) {
      const removeBtn = event.target.closest(SELECTORS.removeItem);
      const decreaseBtn = event.target.closest(SELECTORS.decreaseQuantity);
      const increaseBtn = event.target.closest(SELECTORS.increaseQuantity);

      if (!removeBtn && !decreaseBtn && !increaseBtn) return;

      const lineItem = event.target.closest(SELECTORS.lineItem);
      if (!lineItem) return;

      const lineKey = lineItem.dataset.lineKey;
      const quantityEl = lineItem.querySelector(SELECTORS.quantityValue);
      const currentQuantity = parseInt(quantityEl?.textContent || '1', 10);

      let newQuantity;

      if (removeBtn) {
        newQuantity = 0;
      } else if (decreaseBtn) {
        newQuantity = Math.max(0, currentQuantity - 1);
      } else if (increaseBtn) {
        newQuantity = currentQuantity + 1;
      }

      if (newQuantity !== undefined) {
        lineItem.classList.add('cart-item--loading');
        updateLineItem(lineKey, newQuantity);
      }
    }

    function handleQuickAdd(event) {
      const quickAddBtn = event.target.closest(SELECTORS.quickAdd);
      if (!quickAddBtn) return;

      const variantId = quickAddBtn.dataset.variantId;
      if (!variantId) return;

      quickAddBtn.disabled = true;
      addToCart(variantId, 1);
    }

    function updateLineItem(lineKey, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id: lineKey, quantity: quantity }),
      })
        .then(response => response.json())
        .then(cart => {
          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: {
                cart,
              },
            })
          );
        })
        .catch(error => {
          console.error('Error updating cart:', error);
          refreshCart();
        });
    }

    function addToCart(variantId, quantity) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id: variantId, quantity: quantity }),
      })
        .then(response => response.json())
        .then(item => {
          // Re-enable quick add buttons
          document.querySelectorAll(SELECTORS.quickAdd).forEach(btn => (btn.disabled = false));

          // Dispatch item added event
          document.dispatchEvent(
            new CustomEvent('cart:item-added', {
              detail: {
                product: item.product_title,
                variant: item.variant_title,
                quantity: item.quantity,
                image: item.image ? item.image.replace(/(\.[^.]+)$/, '_200x$1') : null,
                price: Shopify.formatMoney
                  ? Shopify.formatMoney(item.price)
                  : (item.price / 100).toFixed(2),
              },
            })
          );
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          document.querySelectorAll(SELECTORS.quickAdd).forEach(btn => (btn.disabled = false));
        });
    }

    function refreshCart() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: {
                cart,
              },
            })
          );
        })
        .catch(error => {
          console.error('Error fetching cart:', error);
        });
    }

    function updateCartUI(cart) {
      if (!drawer) return;

      const emptyEl = drawer.querySelector(SELECTORS.empty);
      const filledEl = drawer.querySelector(SELECTORS.filled);
      const footerEl = drawer.querySelector(SELECTORS.footer);
      const countEl = drawer.querySelector(SELECTORS.cartCount);
      const subtotalEl = drawer.querySelector(SELECTORS.subtotal);
      const itemsEl = drawer.querySelector(SELECTORS.items);

      const hasItems = cart.item_count > 0;

      // Toggle empty/filled states
      if (emptyEl) emptyEl.style.display = hasItems ? 'none' : 'flex';

      if (filledEl) filledEl.style.display = hasItems ? 'block' : 'none';

      if (footerEl) footerEl.style.display = hasItems ? 'block' : 'none';

      // Update count
      if (countEl) {
        countEl.textContent = `(${cart.item_count})`;
      }

      // Update subtotal
      if (subtotalEl) {
        subtotalEl.textContent = Shopify.formatMoney
          ? Shopify.formatMoney(cart.total_price)
          : (cart.total_price / 100).toFixed(2);
      }

      // Update cart items HTML
      if (itemsEl && cart.items) {
        // Rebuild items - fetch fresh HTML
        fetch(window.location.pathname + '?section_id=cart-drawer')
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newItems = doc.querySelector(SELECTORS.items);
            if (newItems && itemsEl) {
              itemsEl.innerHTML = newItems.innerHTML;
            }
          })
          .catch(error => {
            console.error('Error refreshing cart items:', error);
          });
      }

      // Update drawer data attribute
      drawer.dataset.cartCount = cart.item_count;
    }

    // Refresh the cart whenever the page is shown after a back/forward navigation.
    // When a page is restored from the back/forward cache (bfcache) the cart markup
    // can be stale (e.g. after returning from checkout). event.persisted is true for
    // a true bfcache restore, but some browsers (notably Safari) leave it false while
    // still showing a cached snapshot — so we also fall back to the Navigation Timing
    // API "back_forward" type. Registered at top level (not gated on the drawer) so it
    // always fires; refreshCart() silently re-fetches /cart.js and updates the UI.
    function isBackForwardNavigation() {
      try {
        var entries = performance.getEntriesByType('navigation');
        if (entries && entries.length) return entries[0].type === 'back_forward';
      } catch (e) {}
      return false;
    }

    window.addEventListener('pageshow', function (event) {
      if (event.persisted || isBackForwardNavigation()) {
        refreshCart();
      }
    });

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    const SELECTORS = {
      cartPage: '[data-cart-page]',
      empty: '[data-cart-empty]',
      filled: '[data-cart-filled]',
      items: '[data-cart-items]',
      cartCount: '[data-cart-count]',
      subtotal: '[data-cart-subtotal]',
      lineItem: '[data-line-item]',
      removeItem: '[data-remove-item]',
      decreaseQuantity: '[data-decrease-quantity]',
      increaseQuantity: '[data-increase-quantity]',
      quantityValue: '[data-quantity-value]',
      linePrice: '[data-line-price]',
    };

    let cartPage;

    function init() {
      cartPage = document.querySelector(SELECTORS.cartPage);
      if (!cartPage) return;

      bindEvents();
    }

    function bindEvents() {
      cartPage.addEventListener('click', handleLineItemAction);
      document.addEventListener('cart:updated', handleCartUpdated);
    }

    function handleLineItemAction(event) {
      const removeBtn = event.target.closest(SELECTORS.removeItem);
      const decreaseBtn = event.target.closest(SELECTORS.decreaseQuantity);
      const increaseBtn = event.target.closest(SELECTORS.increaseQuantity);

      if (!removeBtn && !decreaseBtn && !increaseBtn) return;

      const lineItem = event.target.closest(SELECTORS.lineItem);
      if (!lineItem) return;

      const lineKey = lineItem.dataset.lineKey;
      const quantityEl = lineItem.querySelector(SELECTORS.quantityValue);
      const currentQuantity = parseInt(quantityEl?.textContent || '1', 10);

      let newQuantity;

      if (removeBtn) {
        newQuantity = 0;
      } else if (decreaseBtn) {
        newQuantity = Math.max(0, currentQuantity - 1);
      } else if (increaseBtn) {
        newQuantity = currentQuantity + 1;
      }

      if (newQuantity !== undefined) {
        lineItem.classList.add('cart-item--loading');
        updateLineItem(lineKey, newQuantity);
      }
    }

    function updateLineItem(lineKey, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id: lineKey, quantity: quantity }),
      })
        .then(response => response.json())
        .then(cart => {
          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: { cart },
            })
          );
        })
        .catch(error => {
          console.error('Error updating cart:', error);
          window.location.reload();
        });
    }

    function handleCartUpdated(event) {
      const cart = event.detail?.cart;
      if (cart) {
        updateCartUI(cart);
      }
    }

    function updateCartUI(cart) {
      if (!cartPage) return;

      const emptyEl = cartPage.querySelector(SELECTORS.empty);
      const filledEl = cartPage.querySelector(SELECTORS.filled);
      const countEl = cartPage.querySelector(SELECTORS.cartCount);
      const subtotalEl = cartPage.querySelector(SELECTORS.subtotal);
      const itemsEl = cartPage.querySelector(SELECTORS.items);

      const hasItems = cart.item_count > 0;

      if (emptyEl) emptyEl.style.display = hasItems ? 'none' : 'flex';
      if (filledEl) filledEl.style.display = hasItems ? 'flex' : 'none';

      if (countEl) {
        countEl.textContent = `(${cart.item_count})`;
      }

      if (subtotalEl) {
        subtotalEl.textContent = Shopify.formatMoney
          ? Shopify.formatMoney(cart.total_price)
          : (cart.total_price / 100).toFixed(2);
      }

      if (itemsEl && cart.items) {
        fetch(window.location.pathname + '?section_id=cart')
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newItems = doc.querySelector(SELECTORS.items);
            if (newItems && itemsEl) {
              itemsEl.innerHTML = newItems.innerHTML;
            }
          })
          .catch(error => {
            console.error('Error refreshing cart items:', error);
            window.location.reload();
          });
      }

      cartPage.dataset.cartCount = cart.item_count;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Find all contact form sections
    var contactForms = document.querySelectorAll('.contact-form__form');

    contactForms.forEach(function (form) {
      var wrapper = form.closest('.contact-form');
      if (!wrapper) return;

      var subjectSelect = wrapper.querySelector('#contact-subject');
      var recipientInput = wrapper.querySelector('#contact-recipient-email');
      var orderField = wrapper.querySelector('#order-number-field');
      var countryField = wrapper.querySelector('#country-field');

      // Email mapping for subjects
      var emailMap = {
        General: '',
        Support: 'customersupport@drinklang.com',
        Press: 'press@drinklang.com',
        Legal: 'privacy@drinklang.com',
      };

      // Subjects that hide the order number field
      var hideOrderSubjects = ['Press', 'Legal'];

      // Handle subject change
      function handleSubjectChange() {
        var subject = subjectSelect.value;

        // Update hidden recipient email field
        if (recipientInput && emailMap[subject]) {
          recipientInput.value = emailMap[subject];
        }

        // Toggle order number field visibility
        if (orderField && countryField) {
          if (hideOrderSubjects.indexOf(subject) > -1) {
            orderField.classList.add('is-hidden');
            countryField.classList.add('is-expanded');
          } else {
            orderField.classList.remove('is-hidden');
            countryField.classList.remove('is-expanded');
          }
        }
      }

      // Validation functions
      function validateEmail(email) {
        var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
      }

      function showError(input, message) {
        var field = input.closest('.contact-form__field');
        var errorEl = field ? field.querySelector('.contact-form__error-message') : null;

        input.classList.add('contact-form__input--error');

        if (errorEl) {
          errorEl.textContent = message;
          errorEl.classList.add('is-visible');
        }
      }

      function clearError(input) {
        var field = input.closest('.contact-form__field');
        var errorEl = field ? field.querySelector('.contact-form__error-message') : null;

        input.classList.remove('contact-form__input--error');

        if (errorEl) {
          errorEl.textContent = '';
          errorEl.classList.remove('is-visible');
        }
      }

      function validateField(input) {
        var value = input.value.trim();
        var isRequired = input.hasAttribute('required');

        // Clear previous error
        clearError(input);

        // Required field check
        if (isRequired && !value) {
          showError(input, 'This field is required');
          return false;
        }

        // Email validation
        if (input.type === 'email' && value && !validateEmail(value)) {
          showError(input, 'Please enter a valid email address');
          return false;
        }

        return true;
      }

      // Bind subject change event
      if (subjectSelect) {
        subjectSelect.addEventListener('change', handleSubjectChange);

        // Initialize on load
        handleSubjectChange();
      }

      // Bind blur validation to required inputs
      var inputs = form.querySelectorAll('.contact-form__input');

      inputs.forEach(function (input) {
        input.addEventListener('blur', function () {
          validateField(input);
        });

        // Clear error on input
        input.addEventListener('input', function () {
          if (input.classList.contains('contact-form__input--error')) {
            clearError(input);
          }
        });
      });

      // Form submission validation
      form.addEventListener('submit', function (e) {
        var isValid = true;
        var requiredInputs = form.querySelectorAll('.contact-form__input[required]');

        requiredInputs.forEach(function (input) {
          // Skip hidden fields
          var field = input.closest('.contact-form__field');
          if (field && field.classList.contains('is-hidden')) {
            return;
          }

          if (!validateField(input)) {
            isValid = false;
          }
        });

        if (!isValid) {
          e.preventDefault();

          // Focus first error field
          var firstError = form.querySelector('.contact-form__input--error');
          if (firstError) {
            firstError.focus();
          }
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Sticky Header Logic
    var isDesignMode = typeof Shopify !== 'undefined' && Shopify.designMode;

    function initStickyHeader() {
      try {
        if (typeof gsap === 'undefined' || isDesignMode) {
          return;
        }

        const announcementBar = document.querySelector('.announcement-bar');
        const announcementSection = announcementBar?.closest('.shopify-section');
        const headerSection = document.querySelector('.header')?.closest('.shopify-section');
        const header = document.querySelector('.header');

        if (!header || !headerSection) return;

        // Set fixed positioning for header section
        headerSection.style.position = 'fixed';
        headerSection.style.left = '0';
        headerSection.style.right = '0';
        headerSection.style.zIndex = '100';
        header.style.marginTop = '0';

        // Calculate and set initial position immediately (no animation)
        let initialTop = 20;
        if (announcementSection) {
          const announcementBottom = announcementSection.getBoundingClientRect().bottom;
          if (announcementBottom > 20) {
            initialTop = announcementBottom + 20;
          }
        }
        headerSection.style.top = initialTop + 'px';

        let currentTop = initialTop;
        let isFirstUpdate = true;

        function updateHeaderPosition() {
          let targetTop = 20;

          if (announcementSection) {
            const announcementBottom = announcementSection.getBoundingClientRect().bottom;

            // If announcement bar is still visible, position header 20px below it
            // Otherwise, fix it at 20px from top
            if (announcementBottom > 20) {
              targetTop = announcementBottom + 20;
            } else {
              targetTop = 20;
            }
          }

          // Only animate if the target position has changed significantly and not first update
          if (Math.abs(currentTop - targetTop) > 0.5) {
            currentTop = targetTop;

            // Skip animation on first scroll update to prevent jump
            if (isFirstUpdate) {
              headerSection.style.top = targetTop + 'px';
              isFirstUpdate = false;
            } else {
              gsap.killTweensOf(headerSection);
              gsap.to(headerSection, {
                top: targetTop + 'px',
                duration: 0.4,
                ease: 'power2.out',
              });
            }
          }
        }

        // Update on scroll with animation
        window.addEventListener('scroll', updateHeaderPosition, { passive: true });
        window.addEventListener('resize', updateHeaderPosition);
      } catch (e) {
        // Silently fail - header will still work, just without sticky behavior
      }
    }

    document.addEventListener('DOMContentLoaded', initStickyHeader);

    // Run immediately in case DOM is ready
    if (document.readyState !== 'loading') {
      initStickyHeader();
    }

    // Prevent multiple initializations
    if (window.headerNavigationInitialized) {
      return;
    }
    window.headerNavigationInitialized = true;

    function initHeaderNavigation() {
      const header = document.querySelector('.header');
      const toggle = document.querySelector('.header__mobile-toggle');
      const backdrop = document.querySelector('.header__backdrop');
      const mainNav = document.querySelector('.header__nav--main');
      const body = document.body;

      if (!header || !toggle || !backdrop) {
        return;
      }

      const openLabel = toggle.getAttribute('data-open-label');
      const closeLabel = toggle.getAttribute('data-close-label');

      // Drag scroll functionality for main navigation
      let isDragging = false;
      let startX;
      let scrollLeft;

      if (mainNav && window.innerWidth < 1000) {
        mainNav.addEventListener('mousedown', function (e) {
          isDragging = true;
          mainNav.classList.add('is-dragging');
          startX = e.pageX - mainNav.offsetLeft;
          scrollLeft = mainNav.scrollLeft;
          e.preventDefault();
        });

        mainNav.addEventListener(
          'touchstart',
          function (e) {
            isDragging = true;
            startX = e.touches[0].pageX - mainNav.offsetLeft;
            scrollLeft = mainNav.scrollLeft;
          },
          { passive: true }
        );

        mainNav.addEventListener('mouseleave', function () {
          isDragging = false;
          mainNav.classList.remove('is-dragging');
        });

        mainNav.addEventListener('mouseup', function () {
          isDragging = false;
          mainNav.classList.remove('is-dragging');
        });

        mainNav.addEventListener('touchend', function () {
          isDragging = false;
        });

        mainNav.addEventListener('mousemove', function (e) {
          if (!isDragging) return;

          e.preventDefault();
          const x = e.pageX - mainNav.offsetLeft;
          const walk = (x - startX) * 2;
          mainNav.scrollLeft = scrollLeft - walk;
        });

        mainNav.addEventListener(
          'touchmove',
          function (e) {
            if (!isDragging) return;

            const x = e.touches[0].pageX - mainNav.offsetLeft;
            const walk = (x - startX) * 2;
            mainNav.scrollLeft = scrollLeft - walk;
          },
          { passive: true }
        );

        // Prevent click when dragging
        mainNav.addEventListener(
          'click',
          function (e) {
            if (mainNav.classList.contains('is-dragging')) {
              e.preventDefault();
            }
          },
          true
        );
      }

      function toggleMenu() {
        if (header.classList.contains('menu-open')) {
          closeMenu();
        } else {
          openMenu();
        }
      }

      function openMenu() {
        header.classList.add('menu-open');
        body.classList.add('menu-open');
        toggle.setAttribute('aria-expanded', 'true');
        if (closeLabel) {
          toggle.setAttribute('aria-label', closeLabel);
        }
      }

      function closeMenu() {
        header.classList.remove('menu-open');
        body.classList.remove('menu-open');
        toggle.setAttribute('aria-expanded', 'false');
        if (openLabel) {
          toggle.setAttribute('aria-label', openLabel);
        }
      }

      // Toggle button click
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        toggleMenu();
      });

      // Backdrop click
      backdrop.addEventListener('click', function () {
        closeMenu();
      });

      // Close menu on ESC key
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && header.classList.contains('menu-open')) {
          closeMenu();
        }
      });

      // Close menu when clicking menu links (only on mobile)
      if (window.innerWidth < 1000) {
        const menuLinks = document.querySelectorAll('.header__menu-item, .header__secondary-link');
        menuLinks.forEach(function (link) {
          link.addEventListener('click', function () {
            closeMenu();
          });
        });
      }

      // Reinitialize drag on window resize
      let resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          if (window.innerWidth >= 1000 && header.classList.contains('menu-open')) {
            closeMenu();
          }
        }, 250);
      });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHeaderNavigation);
    } else {
      initHeaderNavigation();
    }

    // Cart count update listener
    document.addEventListener('cart:updated', function (event) {
      var cartCounts = document.querySelectorAll('.header__cart-count');

      if (event.detail && event.detail.cart) {
        var itemCount = event.detail.cart.item_count;

        cartCounts.forEach(function (countElement) {
          if (itemCount > 0) {
            countElement.textContent = itemCount;
            countElement.style.display = 'block';
          } else {
            countElement.style.display = 'none';
          }
        });
      }
    });

    // Cart drawer trigger
    document.querySelectorAll('[data-cart-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('cart:open'));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspot"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const backdrop = document.createElement('div');
    backdrop.className = 'hotspot__backdrop';
    document.body.appendChild(backdrop);

    const hideAll = () => {
      document.querySelectorAll('[data-hotspot-id][aria-expanded="true"]').forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
      });
      document.querySelectorAll('.hotspot__card.is-active').forEach(card => {
        card.classList.remove('is-active');
        card.style.cssText = '';
      });
      backdrop.classList.remove('is-active');
    };

    backdrop.addEventListener('click', hideAll);
    document.addEventListener('keydown', event => { if (event.key === 'Escape') hideAll(); });
    document.addEventListener('click', event => {
      if (!event.target.closest('.hotspot[data-section-id]') && !event.target.closest('[data-hotspot-card]')) {
        hideAll();
      }
    });

    document.querySelectorAll('.hotspot__card-close').forEach(btn => {
      btn.addEventListener('click', hideAll);
    });

    const sections = document.querySelectorAll('.hotspot[data-section-id]');
    if (!sections.length) return;

    sections.forEach(section => {
      section.querySelectorAll('[data-hotspot-id]').forEach(button => {
        button.addEventListener('click', () => {
          const targetId = button.getAttribute('data-hotspot-id');
          const card = document.querySelector(`[data-hotspot-card="${targetId}"]`);
          const isOpen = card && card.classList.contains('is-active');
          hideAll();
          if (card && !isOpen) {
            const isMobile = !window.matchMedia('(min-width: 768px)').matches;
            const rect = button.getBoundingClientRect();

            if (isMobile) {
              card.style.left = '50%';
              card.style.top = '50%';
              card.style.right = 'auto';
              card.style.bottom = 'auto';
              card.style.transform = 'translate(-50%, -50%)';
              backdrop.classList.add('is-active');
            } else {
              const x = parseFloat(button.dataset.desktopX || '50');
              const cardW = card.offsetWidth || 220;
              const cardH = card.offsetHeight || 160;
              const gap = 12;
              const pad = 8;

              if (x >= 50) {
                card.style.left = 'auto';
                card.style.right = (window.innerWidth - rect.left + gap) + 'px';
              } else {
                card.style.left = (rect.right + gap) + 'px';
                card.style.right = 'auto';
              }

              const idealTop = rect.top + rect.height / 2 - cardH / 2;
              card.style.top = Math.min(Math.max(pad, idealTop), window.innerHeight - cardH - pad) + 'px';
              card.style.bottom = 'auto';
              card.style.transform = 'none';
            }

            button.setAttribute('aria-expanded', 'true');
            card.classList.add('is-active');
          }
        });

        button.addEventListener('keydown', event => { if (event.key === 'Escape') hideAll(); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var animationsEnabled = window.quoteSettings && window.quoteSettings.enableAnimations;
    var isDesignMode = typeof Shopify !== 'undefined' && Shopify.designMode;

    function reveal(elements) {
      elements.forEach(function (el) {
        el.style.opacity = 1;
        el.style.transform = 'translateY(0)';
      });
    }

    function runAnimation(root) {
      if (!root) return;

      var elements = root.querySelectorAll('.animate');
      if (!elements.length) return;

      if (!animationsEnabled || isDesignMode) {
        reveal(elements);
        return;
      }

      if (typeof gsap === 'undefined') {
        reveal(elements);
        return;
      }

      gsap.killTweensOf(elements);
      gsap.set(elements, {
        autoAlpha: 0,
        y: 20,
      });
      gsap.to(elements, {
        duration: 0.8,
        autoAlpha: 1,
        y: 0,
        stagger: 0.15,
        ease: 'power2.out',
      });
    }

    function registerScrollTrigger(container, sectionId) {
      if (!container) return;

      var elements = container.querySelectorAll('.animate');
      if (!elements.length) return;

      var storageKey = 'scrollTrigger_' + sectionId;
      var scrollTriggerInstance = window[storageKey];

      if (!animationsEnabled || isDesignMode) {
        if (scrollTriggerInstance) {
          scrollTriggerInstance.kill();
          window[storageKey] = null;
        }
        reveal(elements);
        return;
      }

      if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        if (scrollTriggerInstance) {
          scrollTriggerInstance.kill();
          window[storageKey] = null;
        }
        reveal(elements);
        return;
      }

      if (scrollTriggerInstance) {
        scrollTriggerInstance.kill();
      }

      gsap.set(elements, {
        autoAlpha: 0,
        y: 20,
      });

      window[storageKey] = ScrollTrigger.create({
        trigger: container,
        start: 'top 85%',
        once: true,
        onEnter: function () {
          runAnimation(container);
        },
      });
    }

    function init(section) {
      if (!section) return;

      var sectionId = section.getAttribute('data-section-id');
      if (!sectionId) return;

      var settings = section.querySelector('.quote__settings');
      if (settings) {
        window.quoteSettings = {
          enableAnimations: settings.getAttribute('data-enable-animations') === 'true',
        };
        animationsEnabled = window.quoteSettings.enableAnimations;
      }

      registerScrollTrigger(section, sectionId);
    }

    document.addEventListener('DOMContentLoaded', function () {
      var sections = document.querySelectorAll('.quote[data-section-id]');
      sections.forEach(function (section) {
        init(section);
      });
    });

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.quote[data-section-id]');
      if (section) {
        init(section);
      }
    });

    document.addEventListener('shopify:section:select', function (event) {
      var section = event.target.querySelector('.quote[data-section-id]');
      if (section) {
        init(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
